/**
 * Store module mutations file.
 * App.Account
 */
// import _ from 'lodash'
import httpClient from '@/api/http-client'
import { isEmpty, merge } from 'lodash'
import {canMailAccountsAccess} from '@/apps/mail/utils/access'
import {canCrmManagement} from '@/apps/crm/utils/access'
import Vue from "vue";
export default {
  /**
   * Update account profile data
   * @param {*} state
   * @param {*} profile
   */
  setProfile(state, profile = {}) {
    if (!isEmpty(profile)) {
      state.profile = Object.assign({}, state.profile, profile)

      // Set account ID.
      if (isEmpty(state.accountId))
        state.accountId = profile.uuid ? profile.uuid : null
    } else {
      state.profile = state.defaultProfile

      state.accountId = null
    }
  },

  /**
   * Update account sessions data
   * @param {*} state
   * @param {*} sessions
   */
  setSessions(state, sessions = []) {
    state.sessions = sessions
  },
  
  /**
   * Set Authorization tokens
   * @param state
   * @param tokens
   */
  setAuthTokens(state, tokens = {}) {
    state.auth_tokens = tokens
    if (state.auth_tokens.access_token) {
      httpClient.headers = { Authorization: 'Bearer '+state.auth_tokens.access_token}
    }
  },

  /**
   * Обновление списка доступных компаний
   *
   * @param {*} state
   * @param {*} companies
   */
  setCompanies(state, companies) {
    if (Array.isArray(companies)) {
      state.companies = companies.slice()
    } else {
      state.companies = []
    }
  },
  
  /**
   * Добавление компании
   *
   * @param {*} state
   * @param {*} company
   */
  addCompany(state, company){
    let index = state.companies.findIndex(_company => _company.id === company.id )
    if(index<0){
      state.companies.push(company)
    }
  },

  /**
   * Set/Update account accesses
   * @param {*} state
   * @param {*} accesses
   */
  setAccesses(state, accesses) {
    state.accesses = accesses
  },

  /**
   * Set/Update account services
   * @param {*} state
   * @param {*} services
   */
  setServices(state, services) {
    state.services = []

    // Orgstructure
    if (services.indexOf('orgstructure') >= 0) {
      state.services.push({
        routeName: 'org',
        icon: 'mdi-account-multiple-outline',
        name: 'Оргструктура'
      })
    }
  
    // Disc
    state.services.push({
      routeName: 'disk',
      icon: 'mdi-cloud-upload',
      name: 'Диск'
    })
   

    // BPM
    if (services.indexOf('bpm') >= 0) {
      if (state.accesses['bpm'] && state.accesses['bpm']['catalog_access']) {
        state.services.push({
          routeName: 'bpm.catalog',
          icon: 'mdi-play-circle',
          name: 'Каталог БП'
        })
      }
      if (state.accesses['bpm'] && state.accesses['bpm']['executor_access']) {
        state.services.push({
          routeName: 'bpm.monitor',
          icon: 'mdi-calendar-text',
          name: 'Исполнение БП'
        })
      }
      if (state.accesses['bpm'] && state.accesses['bpm']['supervisor_access']) {
        state.services.push({
          routeName: 'bpm.super-monitor',
          icon: 'mdi-view-dashboard',
          name: 'Мониторинг БП'
        })
      }
      if (state.accesses['bpm'] && state.accesses['bpm']['designer_access']) {
        state.services.push({
          routeName: 'bpm.designer',
          icon: 'mdi-tournament',
          name: 'Конструктор БП'
        })
      }
      state.services.push({
        routeName: "bpm.notes",
        icon: "mdi-square-edit-outline",
        name: "Ежедневник"
      });


      // Kanban
      state.services.push({
        routeName: 'bpm.kanban',
        icon: 'mdi-view-week',
        name: 'Канбан-доска',
      })
    }

    // DEBUG - mail
   
    if (state.accesses['mail'] && state.accesses['mail']['client_access']) {
      state.services.push({
        routeName: 'MailService.Client',
        icon: 'mail_outline',
        name: 'Почтовый клиент'
      })
    }
    
    // DEBUG - mail
    state.services.push({
      routeName: 'CRMService.Contacts',
      icon: 'mdi-account-card-details',
      name: 'Контакты'
    })

    if (state.accesses['mail'] && canMailAccountsAccess(state.accesses['mail'])) {
      state.services.push({
        routeName: 'MailService.Management',
        icon: 'mdi-email',
        name: 'Управление почтовыми аккаунтами'
      })
    }

    if (state.accesses['contacts'] && canCrmManagement(state.accesses['contacts'])) {
      state.services.push({
        routeName: 'CRMAdmin.ContactTypes',
        icon: 'mdi-account-settings',
        name: 'CRM администрирование'
      })
    }
    // TimeLine
    if (state.accesses['timeline'] && state.accesses['timeline']['events_list_access']) {
      state.services.push({
        routeName: 'CRMService.Timeline',
        icon: 'mdi-vector-polyline',
        name: 'Таймлайн',
      })
    }
    /*
    //Analytics Old
    state.services.push({
      routeName: 'analytics_old',
      icon: 'mdi-finance',
      name: 'Аналитика',
    })*/
  
    //Analytics
    state.services.push({
      routeName: 'analytics',
      icon: 'mdi-chart-areaspline',
      name: 'Аналитика 2',
    })

    //knowledge Base
    state.services.push({
      routeName: 'kb',
      icon: 'mdi-help-network',
      name: 'База знаний',
    })

    //Help
    state.services.push({
      routeName: 'help',
      icon: 'mdi-help-circle',
      name: 'Помощь',
    })
  },
  

  /**
   * Обновление идентификатора аккаунта
   *
   * @param {*} state
   * @param {*} id
   */
  setAccountId(state, id) {
    state.accountId = id ? id.toLowerCase() : null
  },

  /**
   * Обновление идентификатора группы (компании)
   *
   * @param {Object} state
   * @param {String} id
   */
  setCompanyId(state, id) {
    state.companyId = id ? id.toLowerCase() : null
  },

  /**
   * Обновление идентификатора группы (компании)
   *
   * @param {Object} state
   * @param {Object} anketa
   */
  setAnketa(state, anketa) {
    state.anketaId = anketa.form_id ? anketa.form_id.toLowerCase() : null
    state.anketa = state.anketaId ? anketa : {}
  },

  /**
   * Обновление идентификатора группы (компании)
   *
   * @param {Object} state
   * @param {String} id
   */
  setDepartmentId(state, id) {
    state.departmentId = id ? id.toLowerCase() : null
  },

  /**
   * Обновление идентификатора поста
   *
   * @param {Object} state
   * @param {String} id
   */
  setPostId(state, id) {
    state.postId = id ? id.toLowerCase() : null

    // TODO: needs to detect company ID by post ID?
    // // Set company ID by post ID (state.postId)
    // let company = state.companies.find(_company => {
    //   return (_company.posts || []).some(_post => {
    //     if (_post.id.toLowerCase() == state.postId) {
    //       company = _company
    //       return true
    //     }
    //     return false
    //   })
    // })
    // state.companyId = company && company.id ? company.id.toLowerCase() : null

    // Update/Set api http-client headers
    if (state.postId) httpClient.headers = { 'DMS-POST-ID': state.postId }
  },

  // Logo
  setLogo(state, logo) {
    state.logo = logo
  },

  // isMyPost
  setIsMyPost(state, isMyPost) {
    state.isMyPost = isMyPost
  },

  // Clear all post data: logo, accesses, services, etc
  clearPostData(state) {
    state.logo = {}
    state.accesses = []
    state.services = []
  },
  
  setRefreshingState(state, value) {
    state.isTokenRefreshing = value
  },
  
  setRefreshingCall(state, value) {
    state.refreshingCall = value
  },
  
  //Set Account themes
  setThemes(state, value){
    state.themes = value
  },
  
  addTheme(state, theme){
    state.themes.push(theme)
  },
  
  saveTheme(state, theme){
    let index = state.themes.findIndex( item => (item.id===theme.id && item.system===false) )
    if(index>-1) merge(state.themes[index], theme)
  },
  
  selectTheme(state, id){
    state.themes.map( item => {
      item.selected = false
      if(item.id===id){
        item.selected = true
        Vue.prototype.$vuetify.theme = item.themeContent;
      }
    })
  },
  
  deleteTheme(state, id){
    let index = state.themes.findIndex( theme => (theme.id===id && theme.system===false) )
    if(index>-1) state.themes.splice(index,1)
  },
  
}



// WEBPACK FOOTER //
// ./src/apps/account/store/common/mutations.js